
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reservation",
      function () {
        return require("private-next-pages/reservation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reservation"])
      });
    }
  